<template>
  <div>
    <div id="app" :class="`app-${$route.meta.theme}`">
      <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.4.1/css/all.css" integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz" crossorigin="anonymous"/>
      <b-navbar fixed="top" toggleable="md" type="dark" variant="info" :class="$route.meta.theme">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-navbar-brand :to="$route.meta.customer ? `/customers/${$route.meta.customer}` : '/'">Landscape</b-navbar-brand>
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav v-if="oidcUser && oidcUser.role.indexOf('feature.sysadmin') !== -1">
            <b-nav-item to="/">Home</b-nav-item>
            <b-nav-item to="/server_list">Servers</b-nav-item>
          </b-navbar-nav>
          <!-- right-aligned items -->
          <b-navbar-nav class="ml-auto">
            <!-- logged-in user -->
            <b-nav-item-dropdown v-if="oidcUser" right>
              <template slot="button-content">
                <em v-text="oidcUser.name"/>
              </template>
              <b-dropdown-item @click="signOutOidc">Signout</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <b-container :class="`main-canvas main-${$route.meta.theme}`">
        <router-view/>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'oidcUser',
    ]),
  },
  methods: {
    ...mapActions([
      'signOutOidc',
    ]),
    dashboardLink(pageName) {
      return { name: 'dashboard', params: { pageName } };
    },
  },
};
</script>

<style scoped>
.bg-info {
    background-color: #333 !important;
}
.main-canvas {
  padding-top: 70px;
}
</style>
